import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchMessages, sendMessage } from '../services/patientApi';
import { queryKeys } from '../queryKeys';

export const useMessagesQuery = (conversationId: string | null) =>
  useInfiniteQuery({
    queryKey: queryKeys.messages.list(conversationId ?? ''),
    queryFn: ({ pageParam }) => fetchMessages(conversationId!, pageParam),
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    initialPageParam: 1,
    enabled: !!conversationId,
    gcTime: 0,
  });

export const useSendMessageMutation = (conversationId: string | null) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) => sendMessage(conversationId!, content),
    onSuccess: (newMessage) => {
      const key = queryKeys.messages.list(conversationId ?? '');
      qc.setQueryData(key, (old: any) => {
        if (!old) return old;
        const [firstPage, ...rest] = old.pages;
        return {
          ...old,
          pages: [{ ...firstPage, items: [newMessage, ...firstPage.items] }, ...rest],
        };
      });
    },
  });
};
